import type { ReactNode } from "react";
import { Form, type FormSubmitFn } from "@mdotm/shadcn/mdotm/components";

export type StepBaseProps = {
	title: ReactNode;
	children: ReactNode;
	onSubmitAsync: FormSubmitFn<void>;
	actions?: ReactNode;
	optional: boolean;
	headerActions?: ReactNode;
};

export function StepBase({
	title,
	onSubmitAsync,
	children,
	actions,
	optional,
	headerActions,
}: StepBaseProps): React.JSX.Element {
	return (
		<Form noValidate onSubmitAsync={onSubmitAsync} className="flex-1 flex! flex-col min-h-max">
			<div className={`bg-[var(--global-palette-neutral-0)] min-h-0 flex-1 flex flex-col px-4 pb-4 relative`}>
				<div className="flex justify-between items-center">
					<div className="font-bold text-[20px] mb-6 mt-4">
						{title} <span className="opacity-80 text-sm">{optional ? "Optional" : "Mandatory"}</span>
					</div>
					{headerActions}
				</div>
				{children}
				{actions && <div className="flex justify-end pt-4">{actions}</div>}
			</div>
		</Form>
	);
}
